export function useClient<T>(init: () => T) {
  const data = ref<T>()

  onMounted(() => {
    data.value = init()
  })

  return data
}
